import { render } from "./MaintenanceRegulatoryList.vue?vue&type=template&id=e8be3486&scoped=true"
import script from "./MaintenanceRegulatoryList.vue?vue&type=script&lang=js"
export * from "./MaintenanceRegulatoryList.vue?vue&type=script&lang=js"

import "./MaintenanceRegulatoryList.vue?vue&type=style&index=0&id=e8be3486&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8be3486"]])

export default __exports__